import React, { useState, useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import "../button.css";
import { secretKey } from "../constant/domain.js";
import { Image, Button, Tooltip, Spin } from "antd";
import paperPinIcon from "../assets/icons/detail/paper-pin 2.png";
import keyIcon from "../assets/icons/detail/key 2.png";
import iconSteam from "../assets/icons/home/Steam_icon_logo 1.png";
import iconGame from "../assets/icons/home/joystick 1.png";
import { StateContext } from "../context/reducer";
import { contextConstant } from "../context/constant";
import {
  useCreatePinOrderMutation,
  useRentAccMutation,
  useUnpinOrderMutation,
  useUpdatePinOrderMutation,
} from "../store/mutations/order.mutate.js";
import {
  useGetAccountQuery,
  useGetPinAndBuyOrderQuery,
} from "../store/queries/game/order.query.js";
import { decryptAES } from "../helpers/acc_game.helper.js";
import { socket } from "../helpers/socket.helper.js";
import { useCreateBuyGameMutation } from "../store/mutations/game/game.mutate.js";
import { Statistic } from "antd";
import dayjs from "dayjs";
import { useGetGameDetailQuery } from "../store/queries/game/game.query.js";
import { useWishlistMutation } from "../store/mutations/game/wishlist.mutate.js";
import { debounce, isEmpty } from "lodash";
import { VipDataMock } from "../constant/VipDataMock.js";
import { electronConstants } from "../constant/electron.js";
import PopupError from "../components/PopupConfirm/PopupError.js";
import PopupConfirm from "../components/PopupConfirm/PopupConfirm.js";
import { useGetVipQuery } from "../store/queries/auth.query.js";
import { getRentStatus, getTimesLeft } from "../context/actions.js";
import { useGetNetStatus } from "../store/queries/app.queries.js";
import { useGetRockstarOTP } from "../store/mutations/account/account.mutate.js";
import { parseImages } from "../helpers/parseImages.helper.js";

const { Countdown } = Statistic;

const XemGame = () => {
  const { id } = useParams();
  const [message, setMessage] = useState("");
  const [accData, setAccData] = useState(null);
  const [accountID, setAccountID] = useState(null);

  const [isGameRented, setIsGameRented] = useState(false);
  const [isGameBuy, setIsGameBuy] = useState(false);
  const [isGamePinned, setIsGamePinned] = useState(false);
  const navigate = useNavigate();
  const { state, dispatch } = useContext(StateContext);
  const { data: steamData } = useGetGameDetailQuery(id);
  const { user } = state;
  const { data: vipAllData } = useGetVipQuery(user);

  const net = localStorage.getItem("net");
  const netData = net ? JSON.parse(net) : null;

  const netId = netData?.id ? netData.id : undefined;

  useEffect(() => {
    if (window.electron?.onMainLog) {
      window.electron.onMainLog((msg) => {
        console.log("[MAIN]", msg);
      });
    }
  }, []);


  const { data: accountData } = useGetAccountQuery(accountID);
  const { data: netStatus } = useGetNetStatus(netId);

  const isVip = !!user?.is_vip && user?.is_vip !== "0";
  const isGameFree =
    (!!steamData && steamData.giathue === "0") ||
    (netStatus && !!netStatus.isBuy);

  const { data: pinAndBuyOrder } = useGetPinAndBuyOrderQuery(
    user?.id,
    JSON.parse(id),
    user?.account,
    user?.is_vip
  );
  const { mutateAsync: rentGameMutation } = useRentAccMutation();
  const { mutateAsync: createBuyGameMutation } = useCreateBuyGameMutation();
  const { mutateAsync: createPinOrderMutation } = useCreatePinOrderMutation();
  const { mutateAsync: unpinOrderMutation } = useUnpinOrderMutation();
  const { mutateAsync: updatePinOrderMutation } = useUpdatePinOrderMutation();
  const { mutateAsync: getRockstarOTP, isPending: isGetRockstarOTP } =
    useGetRockstarOTP();
  const { mutateAsync } = useWishlistMutation();
  const [isErrorPopupVisible, setIsErrorPopupVisible] = useState(false);
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [rentOrderId, setRentOrderId] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [isPlayingGame, setIsPlayingGame] = useState(false);
  const [popUpOTP, setPopUpOTP] = useState({
    visible: "",
    title: "",
    message: "",
  });

  const [isCanPin, setIsCanPin] = useState(false);

  const vipData = vipAllData ?? VipDataMock;

  const vipMaxPinAccount = vipData.find(
    (item) => JSON.stringify(item.id) === user?.is_vip
  );

  useEffect(() => {
    dispatch(
      getRentStatus(
        isPlayingGame && isGameRented && !isGamePinned && !isGameBuy
      )
    );
  }, [isPlayingGame, isGameRented, isGamePinned, isGameBuy]);

  const [usernametk, setUsername] = useState("");
  const [thoiGianTSData, setThoiGianTSData] = useState(0);

  useEffect(() => {
    if (thoiGianTSData && isGameRented && !isVip && !isGameFree) {
      const calculatedEndTime = dayjs().add(thoiGianTSData, "second");
      setEndTime(calculatedEndTime);
    } else {
      setEndTime(0);
    }
  }, [thoiGianTSData, isGameRented, isVip]);

  useEffect(() => {
    const isOrderPresent = pinAndBuyOrder?.data?.length ?? 0;
    const validOrder = isOrderPresent
      ? pinAndBuyOrder?.data?.find((item) => item.steam_id === JSON.parse(id))
      : null;

    const canPin =
      !vipMaxPinAccount || isOrderPresent < vipMaxPinAccount.pin_count;
    setIsCanPin(canPin);

    if (validOrder) {
      if (pinAndBuyOrder.type === "pin") {
        setIsGamePinned(true);
        setAccountID(validOrder.platform_account_id);
      } else if (pinAndBuyOrder.type === "buy") {
        setIsGameBuy(true);
        setAccountID(validOrder.id);
      }
    } else if (user) {
      isGamePinned && setIsGamePinned(false);
      isGameBuy && setIsGameBuy(false);
      setAccData(null);
      if (!isOrderPresent) {
        socket.emit("check_rent_order", {
          userID: user.id,
          steamId: JSON.parse(id),
        });
      }
    }
  }, [pinAndBuyOrder]);

  useEffect(() => {
    if (thoiGianTSData && !isVip) {
      dispatch(getTimesLeft(thoiGianTSData));
      const timerId = setTimeout(() => {
        socket.emit("check_rent_order", {
          userID: user?.id,
          steamId: JSON.parse(id),
        });
        setAccData(null);
        setIsGameRented(false);
      }, thoiGianTSData * 1000 + 1000);

      return () => {
        clearTimeout(timerId);
      };
    }
  }, [thoiGianTSData, isVip]);

  useEffect(() => {
    if (!user?.account) {
      return;
    }
    setUsername(user.account);
  }, [user]);

  useEffect(() => {
    socket.on("order_rent", (res) => {
      if (res && res.data && res.data.length > 0) {
        const rentAccount = res.data.filter(
          (order) => order.steam_id === JSON.parse(id)
        );
        if (rentAccount.length) {
          setAccountID(rentAccount[0]?.platform_account_id);
          setIsGameRented(true);
          setThoiGianTSData(res.data[0].remaining_time);
          setRentOrderId(rentAccount[0].id);
        } else {
          setAccountID(null);
          setIsGameRented(false);
          setRentOrderId(null);
          if (isPlayingGame && window.electron.sendToMain) {
            window.electron.sendToMain(electronConstants.LOG_OUT_STEAM);
            setIsPlayingGame(false);
            setAccData(null);
          }
        }
      } else {
        setAccountID(null);
        setIsGameRented(false);
        if (isPlayingGame && window.electron.sendToMain) {
          window.electron.sendToMain(electronConstants.LOG_OUT_STEAM);
          setIsPlayingGame(false);
          setAccData(null);
        }
      }
    });
  }, [socket, user]);

  useEffect(() => {
    if (accountData) {
      setAccData(accountData);
    }
  }, [accountData]);

  const initialHours = 1;
  const [hours, setHours] = useState(initialHours);

  const handleIncrease = () => {
    if (hours < 99) setHours(hours + 1);
  };

  const handleDecrease = () => {
    if (hours > 1) setHours(hours - 1);
  };

  const gameImages = parseImages(steamData?.images);
  const items = gameImages.map((image) => ({
    original: image,
    thumbnail: image,
    thumbnailClass: "custom-thumbnail",
  }));
  //Detail game
  const [activeTab, setActiveTab] = useState("pills-details");
  const [isOpen, setIsOpen] = useState(false);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setIsOpen((prevState) => (tab === "pills-overview" ? !prevState : false));
  };

  const handleConfirmUnpin = () => {
    setPopupMessage(popupStatus.confirmUnPin);
    setIsPopupVisible(true);
  };

  const handleUnpinAccount = async () => {
    setIsPopupVisible(false);
    try {
      const isOrderPresent = pinAndBuyOrder?.data?.length;

      const validOrder = isOrderPresent
        ? pinAndBuyOrder?.data?.find((item) => item.steam_id === JSON.parse(id))
        : null;

      const orderData = {
        orderId: validOrder.id,
      };

      const res = await unpinOrderMutation(orderData);

      if (res) {
        setIsPopupVisible(true);
        setPopupMessage(popupStatus.unPinSuccess);
        setIsGamePinned(false);

        socket.emit("check_rent_order", {
          userID: user?.id,
          steamId: JSON.parse(id),
        });

        if (window.electron.sendToMain) {
          window.electron.sendToMain(electronConstants.LOG_OUT_STEAM);
          setAccData(null);
          setIsPlayingGame(false);
        }
      }
    } catch (error) {
      console.log("Error pinning account:", error);
      setIsErrorPopupVisible(true);
      setErrorMessage(errorPopupStatus.errorOccur);
    }
  };

  const handleConfirmPin = () => {
    if (isGameBuy) {
      setIsErrorPopupVisible(true);
      setErrorMessage(errorPopupStatus.hadBuyGame);
      return;
    }

    if (!isVip) {
      setErrorMessage(errorPopupStatus.needVip);
      setIsErrorPopupVisible(true);
      return;
    }

    if (!accData?.id) {
      setIsErrorPopupVisible(true);
      setErrorMessage(errorPopupStatus.rentBeforePin);
      return;
    }

    if (!isCanPin) {
      setErrorMessage(errorPopupStatus.outOfPinLimit);
      setIsErrorPopupVisible(true);
      return;
    }

    setIsPopupVisible(true);
    setPopupMessage(popupStatus.confirmPin);
  };

  const handlePinAccount = async () => {
    setIsPopupVisible(false);
    try {
      const now = new Date().toISOString();
      const orderData = {
        steam_id: JSON.parse(id),
        user_id: user.id,
        username: user.account,
        account_platform_id: accData.id,
        time_start: now,
      };

      const res = await createPinOrderMutation(orderData);

      if (res) {
        setIsPopupVisible(true);
        setPopupMessage(popupStatus.pinSuccess);
      }
    } catch (error) {
      setIsErrorPopupVisible(true);
      setErrorMessage(errorPopupStatus.errorOccur);
      console.log("Error pinning account:", error);
    }
  };

  const handleLoginInApp = async () => {
    if (isGamePinned) {
      socket.emit("start-playing-pin-game", {
        userId: user.id,
        steamId: JSON.parse(id),
      });
    }

    try {
      if (!accData || !accData.taikhoan || !accData.matkhau) {
        setErrorMessage(errorPopupStatus.errorOccur);
        setIsErrorPopupVisible(true);
        return;
      }

      setPopupMessage(popupStatus.isLoginSteam);
      setIsPopupVisible(true);

      const { taikhoan, matkhau } = accData;

      const gameName = steamData
        ? steamData.tengame.toLowerCase().replace(/\s+/g, "")
        : "";

      if (secretKey) {
        if (isVip && isGamePinned && pinAndBuyOrder.type === "pin") {
          const res = await updatePinOrderMutation({
            id: pinAndBuyOrder.data[0].id,
            time_start: new Date().toISOString(),
          });
          if (res) {
            console.log("Update pin order success");
          }
        }

        const decryptPass = decryptAES(matkhau, secretKey);

        const detail = isEmpty(accData.add_on) ? null : accData.add_on[0];

        setIsPlayingGame(true);

        window.electron.sendToMain("OPEN_STEAM", {
          tksteam: taikhoan,
          pwdsteam: decryptPass,
          gameName: gameName,
          gameId: steamData.steamId,
          other: detail,
        });
      } else {
        setErrorMessage(errorPopupStatus.errorOccur);
        setIsErrorPopupVisible(true);
        console.log("Secret key is undefined.");
      }
    } catch (error) {
      setErrorMessage(errorPopupStatus.errorOccur);
      setIsErrorPopupVisible(true);
      setMessage("Đã xảy ra lỗi khi đăng nhập Steam");
    }
  };

  const handleConfirmRent = async () => {
    if(!user) {
      dispatch({
        type: contextConstant.SET_SHOW_LOGIN_MODAL,
        payload: true,
      });
      return;
    }
    
    if (isGameBuy) {
      setErrorMessage(errorPopupStatus.hadBuyGame);
      setIsErrorPopupVisible(true);
      return;
    }

    if (isVip && isGamePinned) {
      setErrorMessage(errorPopupStatus.hadPinGame);
      setIsErrorPopupVisible(true);
      return;
    }

    if ((!!isVip || !!isGameFree) && !!isGameRented) {
      setErrorMessage(errorPopupStatus.hadRentGame);
      setIsErrorPopupVisible(true);
      return;
    }

    if (
      !isVip &&
      !isGameFree &&
      user?.xu < JSON.parse(steamData.giathue) * hours
    ) {
      setErrorMessage(errorPopupStatus.InsufficientBalance);
      setIsErrorPopupVisible(true);
      return;
    }

    setIsPopupVisible(true);
    setPopupMessage(popupStatus.confirmRent);
  };

  const handleRentGame = async () => {
    setIsPopupVisible(false);
    try {
      const rentData = {
        user_id: user.id,
        username: usernametk,
        times: hours,
        steam_id: !!steamData ? steamData.id : null,
        net_id: netId,
      };

      if (!!isVip) {
        socket.emit("disconnect_vip_rent_order");
      }

      const acc = await rentGameMutation(rentData);

      if (acc) {
        setAccountID(acc.id);
        setIsGameRented(true);
        setPopupMessage(popupStatus.rentSuccess);
        setIsPopupVisible(true);

        socket.emit("check_rent_order", {
          userID: user?.id,
          steamId: JSON.parse(id),
        });
      }
    } catch (error) {
      setErrorMessage(error.response.data.error);
      setIsErrorPopupVisible(true);
    }
  };

  const handleBuyGame = async () => {
    setIsPopupVisible(false);

    try {
      const buyGameData = {
        user_id: user.id,
        username: usernametk,
        amount: !!steamData ? JSON.parse(steamData.giaban) * hours : 0,
        steam_id: !!steamData ? steamData.id : null,
        account_id: accData?.id ?? null,
        rent_order_id: rentOrderId,
      };

      const acc = await createBuyGameMutation(buyGameData);

      if (acc) {
        setAccData(acc);
        setIsGameBuy(true);
        setPopupMessage(popupStatus.buySuccess);
        setIsPopupVisible(true);

        if (isGamePinned) {
          const orderData = {
            orderId: pinAndBuyOrder.data[0].id,
          };
          const res = await unpinOrderMutation(orderData);

          if (res) {
            setIsGamePinned(false);
          }
        }
      }
    } catch (error) {
      setErrorMessage(error.response.data.message);
      setIsErrorPopupVisible(true);
    }
  };

  const popupStatus = {
    rentSuccess: "rentSuccess",
    buySuccess: "buySuccess",
    pinSuccess: "pinSuccess",
    unPinSuccess: "unPinSuccess",
    isLoginSteam: "isLoginSteam",
    confirmRent: "confirmRent",
    confirmBuy: "confirmBuy",
    confirmPin: "confirmPin",
    confirmUnPin: "confirmUnPin",
  };

  const listConfirmPopupItems = [
    {
      key: popupStatus.rentSuccess,
      title: "Chơi game thành công!",
      message:
        'Vui lòng "đăng nhập vào game" để chơi ^^. "Liên hệ hỗ trợ" nếu bạn không thể đăng nhập.',
      button: [
        {
          label: "Đóng",
          className:
            "px-4 py-2 text-sm font-medium text-white bg-[#65C4DF] border border-gray-300 rounded-[30px] shadow-sm opacity-70 hover:opacity-100",
          onClick: () => setIsPopupVisible(false),
        },
      ],
    },
    {
      key: popupStatus.buySuccess,
      title: "Mua game thành công!",
      message: "Sản phẩm đã thêm vào kho game của bạn.",
      button: [
        {
          label: "Đóng",
          className:
            "px-4 py-2 text-sm font-medium text-white bg-[#65C4DF] border border-gray-300 rounded-[30px] shadow-sm opacity-70 hover:opacity-100",
          onClick: () => setIsPopupVisible(false),
        },
      ],
    },
    {
      key: popupStatus.pinSuccess,
      title: "Ghim game thành công",
      message: "Sản phẩm đã thêm vào danh sách ghim của bạn",
      button: [
        {
          label: "Đóng",
          className:
            "px-4 py-2 text-sm font-medium text-white bg-[#65C4DF] border border-gray-300 rounded-[30px] shadow-sm opacity-70 hover:opacity-100",
          onClick: () => setIsPopupVisible(false),
        },
      ],
    },
    {
      key: popupStatus.unPinSuccess,
      title: "Huỷ ghim game thành công!",
      message: "Sản phẩm đã được xoá khỏi danh sách ghim của bạn.",
      button: [
        {
          label: "Đóng",
          className:
            "px-4 py-2 text-sm font-medium text-white bg-[#65C4DF] border border-gray-300 rounded-[30px] shadow-sm opacity-70 hover:opacity-100",
          onClick: () => setIsPopupVisible(false),
        },
      ],
    },
    {
      key: popupStatus.isLoginSteam,
      title: "Đang đăng nhập Steam!",
      message: "Tài khoản của bạn sẽ được đăng nhập vào Steam trong ít phút.",
      button: [
        {
          label: "Đóng",
          className:
            "px-4 py-2 text-sm font-medium text-white bg-[#65C4DF] border border-gray-300 rounded-[30px] shadow-sm opacity-70 hover:opacity-100",
          onClick: () => setIsPopupVisible(false),
        },
      ],
    },
    {
      key: popupStatus.confirmRent,
      title: "Xác nhận chơi game",
      message: "Bạn có muốn chơi game này không?",
      button: [
        {
          label: "Chơi ngay",
          className:
            "px-4 py-2 text-sm font-medium text-white bg-[#1EA9D0] border border-gray-300 rounded-[30px] shadow-sm opacity-70 hover:opacity-100",
          onClick: () => handleRentGame(),
        },
        {
          label: "Đóng",
          className:
            "px-4 py-2 text-sm font-medium text-white bg-[#65C4DF] border border-gray-300 rounded-[30px] shadow-sm opacity-70 hover:opacity-100",
          onClick: () => setIsPopupVisible(false),
        },
      ],
    },
    {
      key: popupStatus.confirmBuy,
      title: "Xác nhận mua game",
      message: "Bạn có muốn mua game này không?",
      button: [
        {
          label: "Mua ngay",
          className:
            "px-4 py-2 text-sm font-medium text-white bg-[#1EA9D0] border border-gray-300 rounded-[30px] shadow-sm opacity-70 hover:opacity-100",
          onClick: () => handleBuyGame(),
        },
        {
          label: "Đóng",
          className:
            "px-4 py-2 text-sm font-medium text-white bg-[#65C4DF] border border-gray-300 rounded-[30px] shadow-sm opacity-70 hover:opacity-100",
          onClick: () => setIsPopupVisible(false),
        },
      ],
    },
    {
      key: popupStatus.confirmPin,
      title: "Xác nhận ghim game",
      message: "Bạn có có muốn thêm game này vào danh sách ghim!",
      button: [
        {
          label: "Xác nhận",
          className:
            "px-4 py-2 text-sm font-medium text-white bg-[#1EA9D0] border border-gray-300 rounded-[30px] shadow-sm opacity-70 hover:opacity-100",
          onClick: () => handlePinAccount(),
        },
        {
          label: "Đóng",
          className:
            "px-4 py-2 text-sm font-medium text-white bg-[#65C4DF] border border-gray-300 rounded-[30px] shadow-sm opacity-70 hover:opacity-100",
          onClick: () => setIsPopupVisible(false),
        },
      ],
    },
    {
      key: popupStatus.confirmPin,
      title: "Xác nhận ghim game",
      message: "Bạn có có muốn thêm game này vào danh sách ghim!",
      button: [
        {
          label: "Xác nhận",
          className:
            "px-4 py-2 text-sm font-medium text-white bg-[#1EA9D0] border border-gray-300 rounded-[30px] shadow-sm opacity-70 hover:opacity-100",
          onClick: () => handlePinAccount(),
        },
        {
          label: "Đóng",
          className:
            "px-4 py-2 text-sm font-medium text-white bg-[#65C4DF] border border-gray-300 rounded-[30px] shadow-sm opacity-70 hover:opacity-100",
          onClick: () => setIsPopupVisible(false),
        },
      ],
    },
    {
      key: popupStatus.confirmUnPin,
      title: "Xác nhận huỷ ghim game",
      message: "Bạn có có muốn xoá game này khỏi danh sách ghim!",
      button: [
        {
          label: "Xác nhận",
          className:
            "px-4 py-2 text-sm font-medium text-white bg-[#1EA9D0] border border-gray-300 rounded-[30px] shadow-sm opacity-70 hover:opacity-100",
          onClick: () => handleUnpinAccount(),
        },
        {
          label: "Đóng",
          className:
            "px-4 py-2 text-sm font-medium text-white bg-[#65C4DF] border border-gray-300 rounded-[30px] shadow-sm opacity-70 hover:opacity-100",
          onClick: () => setIsPopupVisible(false),
        },
      ],
    },
  ];

  const errorPopupStatus = {
    errorOccur: "errorOccur",
    InsufficientBalance: "InsufficientBalance",
    needVip: "needVip",
    outOfPinLimit: "outOfPinLimit",
    hadBuyGame: "hadBuyGame",
    hadPinGame: "hadPinGame",
    hadRentGame: "hadRentGame",
    rentBeforePin: "rentBeforePin",
    exitPageWhilePlaying: "exitPageWhilePlaying",
    disconnected: "disconnected",
  };

  const listConfirmErrorItems = [
    {
      key: errorPopupStatus.errorOccur,
      title: "Cảnh báo!",
      message: "Đã có lỗi xảy ra. Vui lòng liên hệ hỗ trợ!",
      button: [
        {
          label: "Đóng",
          className:
            "mt-4 px-4 py-2 text-sm font-medium text-white bg-[#FF6D6D] border border-gray-300 rounded-[30px] shadow-sm opacity-70 hover:opacity-100",
          onClick: () => setIsErrorPopupVisible(false),
        },
      ],
    },
    {
      key: errorPopupStatus.InsufficientBalance,
      title: "Không đủ số dư!",
      message: "Tài khoản của bạn không đủ số dư để thực hiện giao dịch.",
      button: [
        {
          label: "Đóng",
          className:
            "mt-4 px-4 py-2 text-sm font-medium text-white bg-[#FF6D6D] border border-gray-300 rounded-[30px] shadow-sm opacity-70 hover:opacity-100",
          onClick: () => setIsErrorPopupVisible(false),
        },
      ],
    },
    {
      key: errorPopupStatus.needVip,
      title: "Không thể ghim!",
      message: "Tính năng này hiện không khả dụng.",
      button: [
        {
          label: "Đóng",
          className:
            "mt-2 px-4 py-2 text-sm font-medium text-white bg-[#FF6D6D] border border-gray-300 rounded-[30px] shadow-sm opacity-70 hover:opacity-100",
          onClick: () => setIsErrorPopupVisible(false),
        },
      ],
    },
    {
      key: errorPopupStatus.outOfPinLimit,
      title: "Không thể ghim!",
      message: "Đã đạt tối đa số lượng tài khoản có thể ghim!",
      button: [
        {
          label: "Đóng",
          className:
            "mt-4 px-4 py-2 text-sm font-medium text-white bg-[#FF6D6D] border border-gray-300 rounded-[30px] shadow-sm opacity-70 hover:opacity-100",
          onClick: () => setIsErrorPopupVisible(false),
        },
      ],
    },
    {
      key: errorPopupStatus.hadBuyGame,
      title: "Cảnh báo!",
      message: "Bạn đã mua game này rồi.",
      button: [
        {
          label: "Đóng",
          className:
            "mt-4 px-4 py-2 text-sm font-medium text-white bg-[#FF6D6D] border border-gray-300 rounded-[30px] shadow-sm opacity-70 hover:opacity-100",
          onClick: () => setIsErrorPopupVisible(false),
        },
      ],
    },
    {
      key: errorPopupStatus.hadPinGame,
      title: "Cảnh báo!",
      message: "Bạn đã ghim game này rồi.",
      button: [
        {
          label: "Đóng",
          className:
            "mt-4 px-4 py-2 text-sm font-medium text-white bg-[#FF6D6D] border border-gray-300 rounded-[30px] shadow-sm opacity-70 hover:opacity-100",
          onClick: () => setIsErrorPopupVisible(false),
        },
      ],
    },
    {
      key: errorPopupStatus.hadRentGame,
      title: "Cảnh báo!",
      message: "Bạn đã chơi game này rồi.",
      button: [
        {
          label: "Đóng",
          className:
            "mt-4 px-4 py-2 text-sm font-medium text-white bg-[#FF6D6D] border border-gray-300 rounded-[30px] shadow-sm opacity-70 hover:opacity-100",
          onClick: () => setIsErrorPopupVisible(false),
        },
      ],
    },
    {
      key: errorPopupStatus.rentBeforePin,
      title: "Không thể ghim!",
      message: "Vui lòng chơi game trước khi ghim.",
      button: [
        {
          label: "Đóng",
          className:
            "mt-4 px-4 py-2 text-sm font-medium text-white bg-[#FF6D6D] border border-gray-300 rounded-[30px] shadow-sm opacity-70 hover:opacity-100",
          onClick: () => setIsErrorPopupVisible(false),
        },
      ],
    },
    {
      key: errorPopupStatus.exitPageWhilePlaying,
      title: "Cảnh báo!",
      message:
        "Bạn đang có tài khoản đang chơi, nếu thoát trang này tài khoản của bạn sẽ đăng xuất",
      button: [
        {
          label: "Thoát",
          className:
            "px-4 py-2 text-sm font-medium text-white bg-[#FF6D6D] border border-gray-300 rounded-[30px] shadow-sm opacity-70 hover:opacity-100",
          onClick: () => {
            navigate("/account/1");
            if (window.electron.sendToMain) {
              window.electron.sendToMain(electronConstants.LOG_OUT_STEAM);
              setAccData(null);
              setIsPlayingGame(false);
            }
          },
        },
        {
          label: "Đóng",
          className:
            "px-4 py-2 text-sm font-medium text-white bg-[#4BBEFF] border border-gray-300 rounded-[30px] shadow-sm opacity-70 hover:opacity-100",
          onClick: () => setIsErrorPopupVisible(false),
        },
      ],
    },
    {
      key: errorPopupStatus.disconnected,
      title: "Mất kết nối!",
      message: "Đã mất kết nối đến máy chủ. Vui lòng thử lại sau.",
      button: [
        {
          label: "Đóng",
          className:
            "mt-4 px-4 py-2 text-sm font-medium text-white bg-[#FF6D6D] border border-gray-300 rounded-[30px] shadow-sm opacity-70 hover:opacity-100",
          onClick: () => setIsErrorPopupVisible(false),
        },
      ],
    },
  ];

  const PopupConfirmComponent = () => {
    const popupData = listConfirmPopupItems.find(
      (item) => item.key === popupMessage
    );
    return (
      popupData && (
        <PopupConfirm
          visible={isPopupVisible}
          onClose={() => setIsPopupVisible(false)}
          title={popupData.title}
          content={popupData.message}
          buttons={popupData.button}
        />
      )
    );
  };
  const PopupErrorComponent = () => {
    const popupData = listConfirmErrorItems.find(
      (item) => item.key === errorMessage
    );
    return popupData ? (
      <PopupError
        visible={isErrorPopupVisible}
        onClose={() => setIsErrorPopupVisible(false)}
        title={popupData.title}
        content={popupData.message}
        buttons={popupData.button}
      />
    ) : (
      <PopupError
        visible={isErrorPopupVisible}
        onClose={() => setIsErrorPopupVisible(false)}
        title={"Đã có lỗi xảy ra"}
        content={errorMessage}
        buttons={[
          {
            label: "Đóng",
            className:
              "mt-4 px-4 py-2 text-sm font-medium text-white bg-[#FF6D6D] border border-gray-300 rounded-[30px] shadow-sm opacity-70 hover:opacity-100",
            onClick: () => setIsErrorPopupVisible(false),
          },
        ]}
      />
    );
  };

  const handleGetOTP = () => {
    if (!isEmpty(accData.add_on))
      getRockstarOTP(accData.add_on[0].username)
        .then((res) => {
          setPopUpOTP({
            visible: "success",
            title: "Lấy OTP thành công",
            message: res.data.join(", "),
          });
        })
        .catch(() => {
          setPopUpOTP({
            visible: "error",
            title: "Không lấy được OTP",
            message: "Không tìm thấy OTP trong hệ thống",
          });
        });
  };

  const handleToggleWishlist = debounce((item) => {
    if (!user) {
      dispatch({
        type: contextConstant.SET_SHOW_LOGIN_MODAL,
        payload: true,
      });
      return;
    }
    mutateAsync({ steamId: item.id, isWishlist: !item.isWishlist });
  }, 1000);

  const resetAllState = () => {
    setMessage("");
    setAccData(null);
    setAccountID(null);
    setIsGameRented(false);
    setIsGameBuy(false);
    setIsGamePinned(false);
    setThoiGianTSData(0);
    setEndTime(0);
    setIsPlayingGame(false);
    setRentOrderId(null);
    setErrorMessage(errorPopupStatus.disconnected);
    setIsErrorPopupVisible(true);
  };

  useEffect(() => {
    socket.onDisconnect(resetAllState);

    return () => {
      socket.removeDisconnectHandler(resetAllState);
    };
  }, []);

  return (
    <div className="h-full overflow-y-auto pt-[92px]">
      <section className="relative pt-10">
        <div className="custom--container">
          <div className="grid sm:grid-cols-6 md:sm:grid-cols-7 lg:grid-cols-5">
            {/* Hinh detail */}
            <div className="sm:col-span-3 md:col-span-3 lg:col-span-2">
              {gameImages.length > 0 ? (
                <ImageGallery
                  items={items}
                  showFullscreenButton={false}
                  autoplay={true}
                  renderItem={(item) => (
                    <div className="image-gallery-image-wrapper">
                      <img
                        src={item.original}
                        alt={item.original}
                        className="rounded-xl sm:h-[428px] md:h-[375px] lg:h-[395px] sm:w-full md:w-full lg:w-full object-cover"
                      />
                    </div>
                  )}
                  renderThumbInner={(item) => (
                    <div className="image-gallery-thumbnail-wrapper">
                      <img
                        src={item.thumbnail}
                        alt={item.thumbnail}
                        className="rounded-xl px-[1px] h-[80px] w-[100px] object-cover custom-thumbnail"
                      />
                    </div>
                  )}
                />
              ) : (
                <p>Không có hình ảnh nào</p>
              )}
            </div>

            {/* Chi tiet game */}
            <div className="sm:col-span-3 md:col-span-4 lg:col-span-3 w-full">
              <div className="sm:ml-5 lg:ml-24">
                <div className="h-full bg-[#232334] rounded-lg overflow-hidden">
                  <div className="max-h-[100px] overflow-hidden">
                    <img
                      src="https://cdn.akamai.steamstatic.com/store/home/store_home_share.jpg"
                      alt=""
                    />
                  </div>
                  <div className="pt-0">
                    <div className="px-3">
                      <h5 className="flex items-center justify-between my-3">
                        <div className="sm:text-base md:text-lg lg:text-2xl">
                          {steamData?.tengame}
                        </div>
                        {/* Ghim */}
                        <div className="flex justify-between">
                          <div className="flex items-center bg-[#3E3E59] opacity-80 hover:opacity-100 rounded-3xl px-2 py-1 mr-3">
                            <Button
                              onClick={() => handleToggleWishlist(steamData)}
                              size="small"
                              className={`rounded-3xl text-base ${
                                steamData?.isWishlist
                                  ? "text-red-500 bg-[#3E3E59]"
                                  : "text-white bg-[#3E3E59] "
                              }`}
                              icon={<i className="fas fa-heart" />}
                              style={{
                                border: "none",
                                backgroundColor: "inherit",
                                boxShadow: "none",
                              }}
                            >
                              <span className="text-gray sm:text-sm md:text-md">
                                {steamData?.isWishlist === 1
                                  ? "Bỏ Yêu Thích"
                                  : "Yêu Thích"}
                              </span>
                            </Button>
                          </div>
                          <div className="flex items-center bg-[#3E3E59] opacity-80 hover:opacity-100 rounded-3xl px-2 py-1">
                            <Tooltip
                              placement="topLeft"
                              trigger="hover"
                              title={
                                'Ghim tài khoản để đăng nhập vào đúng tk này vào những lần sau. Lưu ý nếu bạn không "Đăng nhập vào game" trong vòng 7 ngày, hệ thống sẽ tự động gỡ ghim'
                              }
                            >
                              <Button
                                onClick={
                                  !!user ? 
                                    isGamePinned
                                      ? handleConfirmUnpin
                                      : handleConfirmPin
                                    : () => {
                                        dispatch({
                                          type: contextConstant.SET_SHOW_LOGIN_MODAL,
                                          payload: true,
                                        });
                                      }
                                }
                                size="small"
                                className="rounded-3xl text-white bg-[#3E3E59]"
                                icon={
                                  <img
                                    src={paperPinIcon}
                                    alt=""
                                    className="sm:h-3 sm:w-3 md:h-4 md:w-4"
                                  />
                                }
                                style={{
                                  border: "none",
                                  backgroundColor: "inherit",
                                  boxShadow: "none",
                                }}
                              >
                                <span className="text-gray sm:text-sm md:text-md">
                                  {isGamePinned ? "Hủy ghim" : "Ghim"}
                                </span>
                              </Button>
                            </Tooltip>
                          </div>
                        </div>
                      </h5>
                      {/* Icon Steam */}
                      <span className="text-[14px] inline-block">
                        <div className="flex pb-3 space-x-14">
                          <div className="flex items-center">
                            <div className="sm:h-8 sm:w-8 md:h-9 md:w-9 h-10 w-10">
                              <Image src={iconSteam} alt="" preview={false} />
                            </div>
                            <div className="pl-3">
                              <p className="sm:text-[13px] md:text-[15px] text-white text-base">
                                Nền tảng
                              </p>
                              <span className="sm:text-[12px] md:text-[14px] text-base">
                                Steam
                              </span>
                            </div>
                          </div>

                          <div className="flex items-center">
                            <div className="sm:h-8 sm:w-8 md:h-9 md:w-9 h-10 w-10">
                              <Image src={iconGame} alt="" preview={false} />
                            </div>
                            <div className="pl-3">
                              <p className="sm:text-[13px] md:text-[15px] text-white text-base">
                                Chế độ
                              </p>
                              <span className="sm:text-[12px] md:text-[14px] text-base">
                                {steamData?.chedo}
                              </span>
                            </div>
                          </div>
                        </div>
                      </span>
                    </div>
                    {/* Thue va Mua */}
                    <center>
                      <div className="game-ss">
                        <form>
                          <div className="bg-[#3E3E59] mt-3">
                            <div className="w-full">
                              <div className="flex flex-col md:flex-row sm:gap-0 md:gap-4 min-h-[80px]">
                                <div className="flex items-center basis-full">
                                  <div
                                    className={`sm:basis-3/4 md:basis-4/5 ${
                                      !!thoiGianTSData
                                        ? "sm:py-2 md:pt-[8px] lg:pt-[8px]"
                                        : "flex items-center sm:py-5"
                                    }`}
                                  >
                                    {!!endTime && (
                                      <div className="flex basis-3/4 font-[600] items-center sm:px-3 md:px-2 lg:px-4">
                                        <h1 className="font-medium md:text-base lg:text-lg mr-2 text-white">
                                          Thời gian còn lại
                                        </h1>
                                        <Countdown
                                          className="lg:ml-5 sm:px-2 md:pl-6 lg:px-5"
                                          value={endTime}
                                          format="HH Giờ&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;mm phút"
                                        />
                                      </div>
                                    )}
                                    <div className="flex items-center sm:px-3 md:px-2 lg:px-4">
                                      <h1 className="font-medium sm:text-base md:text-base lg:text-lg">
                                        Thời gian chơi
                                      </h1>
                                      {!!isVip || !!isGameFree ? (
                                        <div className="ml-2">
                                          <svg
                                            width="23"
                                            height="12"
                                            viewBox="0 0 23 12"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path
                                              d="M5.4897 0.949573C6.19993 0.949573 6.84801 1.05315 7.43395 1.2603C8.01989 1.46153 8.54664 1.72195 9.0142 2.04155C9.48769 2.36115 9.90199 2.69259 10.2571 3.03587C10.4228 3.18975 10.5678 3.33771 10.6921 3.47976C10.8223 3.61588 10.9496 3.75497 11.0739 3.89702C11.1863 3.75497 11.3047 3.61588 11.429 3.47976C11.5533 3.34363 11.7012 3.19567 11.8729 3.03587C12.4115 2.51503 13.0803 2.03859 13.8793 1.60653C14.6842 1.16856 15.6104 0.949573 16.658 0.949573C17.6523 0.949573 18.5579 1.18928 19.3746 1.66868C20.1914 2.14808 20.8395 2.79025 21.3189 3.59517C21.8042 4.40009 22.0469 5.28788 22.0469 6.25852C22.0469 6.99242 21.9078 7.68194 21.6296 8.32706C21.3514 8.97218 20.9638 9.53741 20.4666 10.0227C19.9754 10.508 19.4042 10.8868 18.7532 11.1591C18.1022 11.4313 17.4038 11.5675 16.658 11.5675C15.9478 11.5675 15.2997 11.4698 14.7138 11.2745C14.1278 11.0733 13.6011 10.8188 13.1335 10.511C12.666 10.2032 12.2546 9.88364 11.8995 9.5522C11.7219 9.38056 11.5681 9.22372 11.4379 9.08168C11.3076 8.93963 11.1863 8.79759 11.0739 8.65554C10.9437 8.8035 10.8134 8.95147 10.6832 9.09943C10.553 9.24148 10.4051 9.3924 10.2393 9.5522C9.89607 9.8718 9.49065 10.1884 9.02308 10.5021C8.55552 10.8099 8.02581 11.0644 7.43395 11.2656C6.84801 11.4669 6.19993 11.5675 5.4897 11.5675C4.49538 11.5675 3.58984 11.3307 2.77308 10.8572C1.95632 10.3778 1.30528 9.73864 0.819957 8.93963C0.334635 8.13471 0.0919745 7.241 0.0919745 6.25852C0.0919745 5.53054 0.231061 4.84695 0.509233 4.20774C0.787405 3.56854 1.17211 3.00627 1.66335 2.52095C2.16051 2.02971 2.73461 1.645 3.38565 1.36683C4.04261 1.08866 4.74396 0.949573 5.4897 0.949573ZM2.98615 6.25852C2.98615 6.70833 3.0986 7.11967 3.32351 7.49254C3.54841 7.85949 3.85026 8.15246 4.22905 8.37145C4.60784 8.58452 5.02805 8.69105 5.4897 8.69105C6.02829 8.69105 6.51953 8.5786 6.96342 8.35369C7.41323 8.12287 7.83937 7.82102 8.24183 7.44815C8.47857 7.22917 8.67981 7.01906 8.84553 6.81783C9.01125 6.61068 9.15329 6.42424 9.27166 6.25852C9.14737 6.0928 8.98757 5.90045 8.79226 5.68146C8.60286 5.46248 8.41939 5.27012 8.24183 5.1044C7.86896 4.74929 7.4517 4.44744 6.99006 4.19886C6.52841 3.95028 6.02829 3.82599 5.4897 3.82599C5.02805 3.82599 4.60784 3.93845 4.22905 4.16335C3.85026 4.38234 3.54841 4.67827 3.32351 5.05114C3.0986 5.41809 2.98615 5.82055 2.98615 6.25852ZM19.1438 6.25852C19.1438 5.82055 19.0314 5.41809 18.8065 5.05114C18.5816 4.67827 18.2797 4.38234 17.9009 4.16335C17.5281 3.93845 17.1138 3.82599 16.658 3.82599C16.2911 3.82599 15.9419 3.88518 15.6104 4.00355C15.2849 4.116 14.9772 4.26989 14.6871 4.4652C14.3971 4.65459 14.1338 4.86766 13.897 5.1044C13.6839 5.30563 13.4798 5.52166 13.2844 5.75249C13.0951 5.98331 12.956 6.15199 12.8672 6.25852C13.0033 6.44792 13.1542 6.64027 13.32 6.83558C13.4857 7.03089 13.678 7.23508 13.897 7.44815C14.2876 7.8151 14.7079 8.11399 15.1577 8.34482C15.6075 8.57564 16.1076 8.69105 16.658 8.69105C17.1138 8.69105 17.5281 8.58452 17.9009 8.37145C18.2797 8.15246 18.5816 7.85949 18.8065 7.49254C19.0314 7.11967 19.1438 6.70833 19.1438 6.25852Z"
                                              fill="white"
                                            />
                                          </svg>
                                        </div>
                                      ) : (
                                        <div className="sm:ml-4 md:ml-5 flex items-center">
                                          <div className="flex items-center rounded-3xl bg-[#56568A] sm:ml-2 md:ml-3 lg:ml-6">
                                            <Button
                                              ghost
                                              type="default"
                                              onClick={handleDecrease}
                                              className="sm:px-2 md:px-[10px] lg:px-3 font-medium bg-[#56568A] sm:text-base md:text-base lg:text-lg text-white opacity-70 hover:opacity-100"
                                              style={{
                                                borderRadius: 200,
                                                border: "none",
                                              }}
                                            >
                                              -
                                            </Button>
                                            <div className="font-medium min-w-5 text-white sm:text-base lg:text-lg">
                                              {hours}
                                            </div>
                                            <Button
                                              ghost
                                              type="default"
                                              onClick={handleIncrease}
                                              className="sm:px-2 md:px-[10px] lg:px-3 font-medium bg-[#56568A] sm:text-base md:text-base lg:text-lg text-white opacity-70 hover:opacity-100"
                                              style={{
                                                borderRadius: 200,
                                                border: "none",
                                              }}
                                            >
                                              +
                                            </Button>
                                          </div>
                                          <span className="sm:ml-10 md:ml-[55px] lg:ml-16 text-white font-medium sm:text-base md:text-base lg:text-lg">
                                            Giờ
                                          </span>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>

                                <div className="flex sm:basis-full md:basis-4/5 lg:basis-4/5 justify-end">
                                  <div className="flex justify-between relative rounded w-full max-h-[80px]">
                                    <>
                                      {
                                        <a
                                          href="##"
                                          onClick={handleConfirmRent}
                                          id="rentButton"
                                          className="flex items-center justify-center w-full text-white bg-[#7C7CD1] "
                                        >
                                          <span></span>
                                          <span></span>
                                          <span></span>
                                          <span></span>
                                          <div className="flex items-center">
                                            <div className="sm:h-7 sm:w-7 md:h-9 md:w-9 h-10 w-10 lg:mr-5">
                                              <img
                                                src={keyIcon}
                                                alt=""
                                                className="mr-2"
                                              />
                                            </div>
                                            <div className="flex-col items-center sm:ml-2">
                                              <p className="text-white sm:mb-0 sm:text-base md:text-base lg:text-lg font-medium">
                                                Chơi game
                                              </p>
                                            </div>
                                          </div>
                                        </a>
                                      }
                                    </>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </center>
                    {/* Đăng nhập steam */}
                    {!!accData &&
                      (isGameBuy || isGamePinned || isGameRented) && (
                        <div className="w-full flex justify-center items-center mt-4">
                          <button
                            onClick={handleLoginInApp}
                            className="bg-[#3E3E59] border border-solid border-white rounded-md py-3 px-5 text-white opacity-70 hover:opacity-100"
                          >
                            Đăng nhập vào game
                          </button>
                          {!isEmpty(accData.add_on) && (
                            <button
                              disabled={isGetRockstarOTP}
                              onClick={handleGetOTP}
                              className={`ml-4 relative py-3 px-5 rounded-lg bg-gradient-to-r from-purple-500 via-pink-500 to-red-500 
        text-white font-bold text-lg overflow-hidden transition-all duration-500
        hover:scale-105 hover:shadow-[0_0_40px_rgba(255,0,255,0.5)] 
        active:scale-95
        before:absolute before:inset-0
        before:bg-gradient-to-r before:from-transparent before:via-white before:to-transparent before:opacity-20
        before:translate-x-[-200%] hover:before:translate-x-[200%] before:transition-transform before:duration-1000 ${
          isGetRockstarOTP ? "opacity-50 cursor-not-allowed" : ""
        }`}
                            >
                              {" "}
                              {isGetRockstarOTP ? (
                                <>
                                  <Spin className="mr-2" />
                                  Đang lấy OTP
                                </>
                              ) : (
                                "Lấy OTP"
                              )}
                            </button>
                          )}
                        </div>
                      )}
                    {/* Mô Tả Chi Tiết */}
                    <div className="rounded-b-sm sm:my-3 md:my-4 lg:my-[19px] ml-2">
                      <ul
                        className="custom--tab nav nav-pills py-2 border-b-2 border-gray-500"
                        id="pills-tab"
                        role="tablist"
                      >
                        <li
                          className="nav-item opacity-70 hover:opacity-100"
                          role="presentation"
                        >
                          <button
                            className={`text-white !font-medium ${
                              activeTab === "pills-overview" ? "active" : ""
                            }`}
                            id="pills-overview-tab"
                            onClick={() => {
                              setIsOpen(isOpen);
                              handleTabChange("pills-overview");
                            }}
                          >
                            Mô tả chi tiết
                            <span className="ml-2">
                              {isOpen ? (
                                <i className="fa fa-chevron-down"></i>
                              ) : (
                                <i className="fa fa-chevron-right"></i>
                              )}
                            </span>
                          </button>
                        </li>
                      </ul>
                      <div
                        className={`transition-all duration-500 ease-in-out ${
                          isOpen
                            ? "max-h-screen opacity-100"
                            : "max-h-0 opacity-0"
                        } overflow-hidden`}
                      >
                        <div className="container custom_detail-text mt-2">
                          <div
                            dangerouslySetInnerHTML={{
                              __html: steamData?.mota,
                            }}
                          ></div>
                        </div>
                      </div>
                    </div>

                    {/*  */}
                  </div>
                </div>
                {message && <p>{message}</p>}
              </div>
              {/* Accordion Start */}
              <div className="product-details-content__accordion mt-5">
                <div
                  className="accordion custom--accordion style-two"
                  id="accordionExample"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {PopupConfirmComponent()}
      {PopupErrorComponent()}
      <PopupConfirm
        visible={popUpOTP.visible === "success"}
        onClose={() => setPopUpOTP({ ...popUpOTP, visible: false })}
        title={popUpOTP.title}
        content={popUpOTP.message}
        buttons={[
          {
            label: "Đóng",
            className:
              "px-4 py-2 text-sm font-medium text-white bg-[#65C4DF] border border-gray-300 rounded-[30px] shadow-sm opacity-70 hover:opacity-100",
            onClick: () => setPopUpOTP({ ...popUpOTP, visible: false }),
          },
        ]}
      />

      <PopupError
        visible={popUpOTP.visible === "error"}
        onClose={() => setPopUpOTP({ ...popUpOTP, visible: false })}
        title={popUpOTP?.title}
        content={popUpOTP?.message}
        buttons={[
          {
            label: "Đóng",
            className:
              "mt-4 px-4 py-2 text-sm font-medium text-white bg-[#FF6D6D] border border-gray-300 rounded-[30px] shadow-sm opacity-70 hover:opacity-100",
            onClick: () => setPopUpOTP({ ...popUpOTP, visible: false }),
          },
        ]}
      />
    </div>
  );
};

export default XemGame;
